export default __webpack_public_path__ + "static/Mac_beta-357adc1f034e63490034cc19826fa0d4.png";